import React, { useState } from 'react';
import { useNavigate } from 'src/utils/useNavigate';
import Button from 'src/components/Button';
import ContentLayout from 'src/components/ContentLayout';
import SBPLogo from 'src/components/SBPLogo';
import Text from 'src/components/Text';
import HelpLink from 'src/components/HelpLink';
import routes from 'src/constants/routes';
import StartRecoveryForm from './StartRecoveryForm';
import PhoneRecoveryForm from './PhoneRecoveryForm';
import EmailRecoveryForm from './EmailRecoveryForm';
import SetPasswordForm from './SetPasswordForm';
import styles from './styles.module.scss';

enum STEPS {
  startRecovery = 'startRecovery',
  phoneRecovery = 'phoneRecovery',
  emailRecovery = 'emailRecovery',
  setPassword = 'setPassword',
  success = 'success',
}

const PasswordRecovery: React.FC = () => {
  const navigate = useNavigate();
  
  const [step, setStep] = useState(STEPS.startRecovery);
  const [authorizationInfo, setAuthorizationInfo] = useState();
  
  const handleStartRecoverySubmit = (authorizationInfo: any, recoveryType: any) => {
    setAuthorizationInfo(authorizationInfo);
    if (recoveryType === 'phone') {
      setStep(STEPS.phoneRecovery);
    }else if (recoveryType === 'email') {
      setStep(STEPS.emailRecovery);
    }
  };
  
  const handlePhoneRecoverySubmit = () => {
    setStep(STEPS.setPassword);
  };
  
  const handlePhoneRecoveryError = () => {
    setStep(STEPS.startRecovery);
  }
  
  const handleEmailRecoverySubmit = () => {
    setStep(STEPS.setPassword);
  };
  
  const handleSetPasswordSubmit = () => {
    setStep(STEPS.success);
  };
  
  const handleSuccessClick = () => {
    navigate(routes.agent);
  }
  
  return (
    <ContentLayout size="small">
      <HelpLink className={styles['help']}/>
      <SBPLogo className={styles['sbp-logo']} />
      {step !== STEPS.success && (
        <Text type="h2" className={styles['title']}>Восстановление пароля</Text>
      )}
      {step === STEPS.startRecovery && (
        <StartRecoveryForm onSubmit={handleStartRecoverySubmit}/>
      )}
      {step === STEPS.phoneRecovery && (
        <PhoneRecoveryForm
          authorizationInfo={authorizationInfo}
          onSubmit={handlePhoneRecoverySubmit}
          onError={handlePhoneRecoveryError}
        />
      )}
      {step === STEPS.emailRecovery && (
        <EmailRecoveryForm authorizationInfo={authorizationInfo} onSubmit={handleEmailRecoverySubmit}/>
      )}
      {step === STEPS.setPassword && (
        <SetPasswordForm authorizationInfo={authorizationInfo} onSubmit={handleSetPasswordSubmit}/>
      )}
      {step === STEPS.success && (
        <>
          <Text type="p" className={styles['text']}>Пароль изменен</Text>
          <div className={styles['button-wrapper']}>
            <Button onClick={handleSuccessClick}>
              Войти
            </Button>
          </div>
        </>
      )}
    </ContentLayout>
  );
};

export default PasswordRecovery;
